import { render, staticRenderFns } from "./block-document-share-participant-item.vue?vue&type=template&id=44f405d2&scoped=true&lang=pug"
import script from "./block-document-share-participant-item.vue?vue&type=script&lang=js"
export * from "./block-document-share-participant-item.vue?vue&type=script&lang=js"
import style0 from "./block-document-share-participant-item.vue?vue&type=style&index=0&id=44f405d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f405d2",
  null
  
)

export default component.exports